/**
 * Memorable session name generation for CLI sessions.
 * Generates names in the format: adjective-noun-number (e.g., "sunny-falcon-42")
 */

const ADJECTIVES = [
  "bright",
  "calm",
  "clever",
  "cool",
  "crisp",
  "eager",
  "fair",
  "fancy",
  "fast",
  "fresh",
  "gentle",
  "glad",
  "golden",
  "green",
  "happy",
  "jolly",
  "keen",
  "kind",
  "lively",
  "lucky",
  "merry",
  "neat",
  "nice",
  "noble",
  "peppy",
  "perky",
  "pink",
  "proud",
  "quick",
  "quiet",
  "rapid",
  "ready",
  "red",
  "rich",
  "rosy",
  "royal",
  "sharp",
  "shiny",
  "silver",
  "sleek",
  "smart",
  "smooth",
  "snappy",
  "solar",
  "steady",
  "sunny",
  "super",
  "sweet",
  "swift",
  "tidy",
  "vivid",
  "warm",
  "wild",
  "wise",
  "witty",
  "young",
] as const;

const NOUNS = [
  "arrow",
  "badge",
  "bear",
  "bird",
  "blade",
  "bolt",
  "brook",
  "cloud",
  "coral",
  "crane",
  "creek",
  "crown",
  "delta",
  "dove",
  "eagle",
  "ember",
  "falcon",
  "flame",
  "flash",
  "frost",
  "gem",
  "grove",
  "hawk",
  "heart",
  "heron",
  "hill",
  "jade",
  "lake",
  "leaf",
  "lion",
  "lotus",
  "maple",
  "moon",
  "oak",
  "ocean",
  "olive",
  "otter",
  "owl",
  "panda",
  "pearl",
  "pine",
  "plum",
  "raven",
  "reef",
  "ridge",
  "river",
  "robin",
  "rose",
  "sage",
  "shell",
  "snow",
  "spark",
  "star",
  "stone",
  "storm",
  "stream",
  "sun",
  "swan",
  "tiger",
  "tree",
  "wave",
  "willow",
  "wind",
  "wolf",
] as const;

/**
 * Generates a base session name in the format: adjective-noun
 * Examples: "sunny-falcon", "calm-river", "bright-star"
 *
 * With ~56 adjectives and ~64 nouns, there are ~3,584 base combinations.
 * Numbers are appended by the session module only when needed to avoid collisions.
 */
export function generateSessionName(): string {
  const adjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  return `${adjective}-${noun}`;
}
